import React from 'react';
import PropTypes from 'prop-types';

import { formatAlertsDate } from '@Utils/String';

import './AlertSinceDate.custom.scss';
import './AlertSinceDate.theme.scss';


export default function AlertSinceDate (props) {
  const { lastSaved } = props;
  const lastSavedFormatted = formatAlertsDate(lastSaved);

  return (
    <section className='alert-since-date alerts--second-line'>
      Since {lastSavedFormatted}
    </section>
  );
}

AlertSinceDate.propTypes = {
  lastSaved: PropTypes.string.isRequired,
};
